import React from 'react'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { useCmsBlock } from 'lib/core/hooks'
import { Wrapper } from './styled'

export const Benefits = () => {
  const blockId = CMS_BLOCK.PPL_BENEFITS
  const benefitsContent = useCmsBlock({
    id: blockId
  })

  if (!benefitsContent.content) return null
  return (
    <Wrapper
      dangerouslySetInnerHTML={{
        __html: benefitsContent.content
      }}
    />
  )
}
